import * as types from './types'
import storage from '@/plugins/storage'
import global from '@/plugins/global'
import store from '@/store'
const NEW_WORK_ORDER = {
  Id: 0,
  IsMil: false,
  IsSRS: false,
  IsDrivable: false,
  RONumber: null,
  CreatedBy: 0,
  CreatedDate: null,
  UpdatedBy: 0,
  UpdatedDate: null,
  ShopComments: '',
  ScanReport: {
    Id: 0,
    InvoiceNumber: null,
    MasterTechnician: null,
    Recommendations: null,
    ScanReadings: null,
    ServiceDetails: null,
    SnapshotData: null,
    TimeCompleted: null,
    CreatedBy: 0,
    CreatedDate: null,
    Status: {
      Id: 0,
      Text: null
    },
    BillingType: {
      Id: 0,
      Text: null
    },
    IsFollowupScan: 0,
    TotalAfterDiscount: null,
    CurrencyCode: null,
    MSRP: 0,
    Discount: 0,
    OtherInvoice: null,
    IsRevised: false,
    MobileReasonText: null,
    MobileNotes: null
  },
  ScheduleDates: null,
  Status: {
    Id: 0,
    Name: null
  },
  Location: {
    Id: 0,
    Name: '',
    Address1: '',
    City: '',
    Country: '',
    ZipCode: '',
    Phone: '',
    ContactName: '',
    StateName: '',
    TimeZone: ''
  },
  Device: {
    Id: 0,
    FriendlyName: '',
    SerialNumber: null
  },
  ScanType: {
    Id: 0,
    Name: null
  },
  Notes: {
    Notes: null,
    CreatedDate: null,
    CreatedBy: 0,
    UpdatedDate: null,
    UpdatedBy: 0
  },
  Contact: {
    Id: 0,
    GivenName: '',
    FamilyName: '',
    PhoneNumber: '',
    FaxNumber: null,
    Email: ''
  },
  Vehicle: {
    Id: 0,
    VIN: '',
    Year: 2000,
    Odometer: 0,
    Make: {
      Id: 0,
      Text: null
    },
    Model: {
      Id: 0,
      Text: null
    },
    Submodel: {
      Id: 0,
      Text: null
    },
    Engine: {
      Id: 0,
      Liter: null,
      CID: null,
      Cylinders: null,
      BlockType: null
    },
    Transmission: {
      Id: 0,
      Text: null
    },
    DriveType: {
      Id: 0,
      Text: null
    },
    Insurance: {
      Id: 0,
      Text: null
    },
    OdometerUnits: {
      Id: 0,
      Text: null
    },
    Damages: null
  },
  DTCs: null,
  NumberPreviousScans: 0,
  PreviousScans: []
}
export default {
  [types.SET_NEW_WORK_ORDER](state) {
    state.newWorkOrder = JSON.parse(JSON.stringify(NEW_WORK_ORDER))
    state.workOrder = JSON.parse(JSON.stringify(NEW_WORK_ORDER))
  },
  [types.SET_WORK_ORDER_LOCATION](state, location) {
    if (state.workOrder !== undefined && state.workOrder !== null) {
      state.workOrder.Location = location
    }
  },
  [types.SET_WORK_ORDER_DEVICES](state, devices) {
    let _devices = []
    if (devices !== undefined && devices !== null) {
      for (let item of devices) {
        _devices.push({
          value: item.SerialNumber,
          name: item.FriendlyName + ' (' + item.Status.Text + ')',
          id: item.Id,
          friendlyName: item.FriendlyName
        })
      }
    }
    state.devices = _devices
  },
  [types.SET_VIEW_DASHBOARD](state, view) {
    state.viewDashboard = view
    storage.local.setItem(types.SET_VIEW_DASHBOARD, view)
  },
  [types.SET_VIEW_SECTION](state, view) {
    state.viewSection = view
    storage.local.setItem(types.SET_VIEW_SECTION, view)
  },
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = parseInt(days)
    storage.local.setItem(types.WORKORDER_DAYS, days)
  },
  [types.SET_STATUS](state, status) {
    state.status = status
    storage.local.setItem(types.WORKORDER_STATUS, status)
  },
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
      storage.session.setItem(types.WORKORDER_SEARCH_TERM, text)
    }
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = parseInt(pageSize)
    storage.local.setItem(types.WORKORDER_PAGE_SIZE, pageSize)
  },
  [types.WORKORDER_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.WORKORDER_SORT_DIR, sortDir)
  },
  [types.WORKORDER_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.WORKORDER_ORDER_BY, orderBy)
  },
  [types.SET_SHOP_DEVICE](state, device) {
    state.shopDevice = {
      FriendlyName: device.friendlyName,
      Id: device.id,
      SerialNumber: device.value
    }
    state.workOrder.Device = {
      FriendlyName: device.friendlyName,
      Id: device.id,
      SerialNumber: device.value
    }
    for (let workOrder of state.workOrders.items) {
      if (workOrder.id === state.workOrder.Id) {
        workOrder.deviceId = device.id
        workOrder.deviceFriendlyName = device.friendlyName
        workOrder.deviceSerialNumber = device.value
        break
      }
    }
  },
  [types.SET_DEVICE_PROTOCOL](state, data) {
    if (state.hubData !== null && state.hubData !== undefined) {
      state.hubData.pairInfo.appLayerProtocol = data
    }
  },
  [types.SET_DEVICE_INTERFACE](state, data) {
    if (state.hubData !== null && state.hubData !== undefined) {
      state.hubData.pairInfo.appLayerInterface = data
    }
  },
  [types.SET_SEARCH_COMPLETED](state, id) {
    let role = store.getters['auth/primaryRole']
    state.searchTerm = id.toString()
    state.isCompletedOnly = true
    if (role !== 'Tech' && role !== 'MasterTech' && role !== 'ReviewTech') {
      state.filterBy = 6 // Completed
    }
    state.status = 'Completed'
  },
  [types.SET_MOBILE_HANDOFF](state, data) {
    state.mobileHandoff = data
  },
  [types.SET_TEAM_ONLY_VIEW](state, data) {
    state.isTeamOnly = data
  },
  [types.SET_COMPLETED_ONLY_VIEW](state, data) {
    let role = store.getters['auth/primaryRole']
    state.isCompletedOnly = data
    if (role !== 'Tech' && role !== 'MasterTech' && role !== 'ReviewTech') {
      state.filterBy = 6
    }
    state.status = 'Completed'
  },
  [types.RESET_COMPLETED_ONLY_VIEW](state, data) {
    state.isCompletedOnly = false
    state.status = ''
    state.searchTerm = ''
  },
  [types.WORKORDER_FILTER_BY](state, data) {
    if (data.filter !== undefined) {
      if (data.filter !== 110) {
        state.filterBy = parseInt(data.filter)
        storage.local.setItem(types.WORKORDER_FILTER_BY, parseInt(state.filterBy))
        if (data.role === 'Tech' || data.role === 'MasterTech' || data.role === 'ReviewTech') {
          // Set Tech's status
          if (data.filter === 1 || data.filter === 80) {
            state.status = 1
          }
        } else {
          state.status = ''
          state.orderBy = 'Id'
          state.sortDir = 'asc'
          // Filter the Listing
          switch (state.filterBy) {
            case 0:
              // Order by Date/Time
              state.status = 'Submitted'
              state.orderBy = 'CreatedDate'
              state.sortDir = 'desc'
              break
            case 1:
              // Working
              state.status = 'Working'
              state.sortDir = 'desc'
              break
            case 2:
              // Unassigned
              break
            case 3:
              // TBD
              state.status = 'Submitted'
              state.sortDir = 'desc'
              break
            case 4:
              // Submitted
              state.status = 'Submitted'
              state.sortDir = 'desc'
              break
            case 5:
              // Scheduled
              state.status = 'Scheduled'
              state.sortDir = 'desc'
              break
            case 6:
              // Completed
              state.status = 'Completed'
              break
            case 7:
              // Voided
              state.status = 'Voided RO'
              break
            case 8:
              // Cancelled
              state.status = 'Cancelled'
              break
            case 9:
              // Scheduled
              state.status = 'dispatch: Scheduled'
              state.sortDir = 'desc'
              break
            case 10:
              // Assigned
              state.status = 'dispatch: Assigned'
              break
            case 11:
              // Unassigned
              state.status = 'dispatch: Submitted'
              state.sortDir = 'desc'
              break
            case 12:
              // Reassigned
              state.status = 'dispatch: Reassign'
              state.sortDir = 'desc'
              break
            case 13:
              // Waiting on Shop
              state.status = 'dispatch: Waiting on Shop'
              state.sortDir = 'desc'
              break
            case 14:
              // Suite 100
              state.status = 'dispatch: Suite 100'
              break
            case 80:
              // Tech/Master Tech listing
              state.status = 'Submitted,Working,Scheduled,Paused,Escalated'
              break
            case 81:
              // In-Shop Tech 'Pending' listing
              state.status = 'Pending'
              break
            case 99:
              // All
              state.status = 'ALL'
              break
            case 110:
              // Technician
              break
          }
        }
      }
    }
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    // console.log('set_filter_options', state, type)
    if (data.role === 'Tech' || data.role === 'MasterTech' || data.role === 'ReviewTech') {
      state.filterOptions = [{
          name: 'Available',
          value: 1
        },
        {
          name: 'Away',
          value: 0
        }
      ]
    } else if (data.role === 'Dispatch') {
      state.filterOptions = [{
          name: 'Technicians',
          value: 110
        },
        {
          name: 'Scheduled Only',
          value: 9
        },
        {
          name: 'Assigned',
          value: 10
        },
        {
          name: 'Unassigned',
          value: 11
        },
        {
          name: 'Reassign',
          value: 12
        },
        {
          name: 'Waiting on Shop',
          value: 13
        },
        {
          name: 'Suite 100',
          value: 14
        },
        {
          name: 'All',
          value: 99
        }
      ]
      if (data.viewing === 'DispatchQueue') {
        state.filterOptions.shift()
      }
    } else {
      state.filterOptions = [{
          name: 'Technicians',
          value: 110
        },
        {
          name: 'Sort by Submit Time',
          value: 0
        },
        {
          name: 'Working',
          value: 1
        },
        // { name: 'Unassigned', value: 2 },
        {
          name: 'Submitted Only',
          value: 4
        },
        {
          name: 'Scheduled Only',
          value: 5
        },
        {
          name: 'Completed Only',
          value: 6
        },
        {
          name: 'Voided Only',
          value: 7
        },
        // {
        //   name: 'Cancelled',
        //   value: 8
        // },
        // { name: 'Priority', value: 8 },
        {
          name: 'All',
          value: 99
        }
      ]
      if (data.viewing === 'DispatchQueue') {
        state.filterOptions.shift()
      }
    }
  },
  [types.SET_STATE_DEFAULT](state, type) {
    state.stateDefaults = {
      notesAssembled: 'Vehicle is fully assembled. ',
      notesDisassembled: 'Vehicle is disassembled. ',
      notesStateSRS: 'Vehicle has SRS deployment(s): ',
      notesStateSRSon: 'Vehicle has SRS deployment(s) [XX]. ',
      notesStateSRSoff: 'SRS not deployed. ',
      notesWarningLights: 'Warning lights illuminated: ',
      notesWarningLightsOn: 'Warning lights illuminated [XX]. ',
      notesWarningLightsOff: 'No warning lights illuminated. ',
      notesBatterySupported: 'Battery supported. ',
      notesBatteryNotSupported: 'Battery not supported. ',
      notesKeyEngineStateKOEO: 'Key on, engine off. ',
      notesKeyEngineStateKOER: 'Key on, engine running. '
    }
  },
  [types.SET_STATE_ASSEMBLY](state, type) {
    state.stateAssemblyOptions = [{
        name: 'select option',
        value: ''
      },
      {
        name: 'Disassembled',
        value: 'Disassembled'
      },
      {
        name: 'Assembled',
        value: 'Assembled'
      }
    ]
  },
  [types.SET_STATE_SRS](state, type) {
    state.stateSrsOptions = [{
        name: 'None',
        value: 'None'
      },
      {
        name: 'Curtain',
        value: 'Curtain'
      },
      {
        name: 'Dash',
        value: 'Dash'
      },
      {
        name: 'Headrests',
        value: 'Headrests'
      },
      {
        name: 'Seat Belts',
        value: 'Seat Belts'
      },
      {
        name: 'Side Airbags',
        value: 'Side Airbags'
      },
      {
        name: 'Steering Wheel/Column',
        value: 'Steering Wheel/Column'
      },
      {
        name: 'Other [XX]',
        value: 'Other [XX]'
      }
    ]
  },
  [types.SET_STATE_LIGHTS](state, type) {
    state.stateLightOptions = [{
        name: 'None',
        value: 'None'
      },
      {
        name: 'ABS/Traction',
        value: 'ABS/Traction'
      },
      {
        name: 'Check Engine',
        value: 'Check Engine'
      },
      {
        name: 'Driver Assist',
        value: 'Driver Assist'
      },
      {
        name: 'SRS',
        value: 'SRS'
      },
      {
        name: 'TPMS',
        value: 'TPMS'
      },
      {
        name: 'Other [XX]',
        value: 'Other [XX]'
      }
    ]
  },
  [types.SET_STATE_KEY_ENGINE](state, type) {
    state.stateKeyEngineOptions = [{
        name: 'select option',
        value: ''
      },
      {
        name: 'Key On, Engine Off',
        value: 'KOEO'
      },
      {
        name: 'Key On, Engine Running',
        value: 'KOER'
      }
    ]
  },
  [types.SET_STATE_DAMAGE_LEVEL](state, type) {
    state.stateDamageLevelOptions = [{
        name: 'select option',
        value: ''
      },
      {
        name: 'Light',
        value: 'Light'
      },
      {
        name: 'Moderate',
        value: 'Moderate'
      },
      {
        name: 'Severe',
        value: 'Severe'
      }
    ]
  },
  [types.SET_STATE_DAMAGE_POSITION](state, type) {
    state.stateDamagePositionOptions = []
    for (let position of state.damagePositions) {
      state.stateDamagePositionOptions.push({
        name: position.text,
        value: position.text
      })
    }
  },
  [types.SET_WORK_ORDER](state, data) {
    state.workOrder = null
    state.devices = []
    state.protocols = store.getters['lookups/lookupsZeus']['device.applayerprotocol']
    state.interfaces = store.getters['lookups/lookupsZeus']['device.appinterface']
    state.statuses = store.getters['lookups/lookupsZeus']['workorder.status']
    state.scanTypes = store.getters['lookups/lookupsZeus']['workorder.servicetype']
    state.odometerUnits = []
    state.insurances = []
    state.timeZones = []
    state.years = []
    state.contacts = []
    state.apiUrl = ''
    state.damagePositions = []
    state.repairLines = null
    state.workOrderHistory = null
    state.lineCount = 0
    if (data !== null) {
      if (data.error !== undefined) {
        console.log('Set Work Order', data.error)
      } else {
        state.workOrder = data[0].ServiceRequest[0]
        state.mobileHandoff = {
          id: state.workOrder.Id,
          isHandoff: state.workOrder.ScanReport.IsMobileHandoff,
          reasonId: state.workOrder.ScanReport.MobileReasonId,
          notes: state.workOrder.ScanReport.MobileNotes
        }
        // Devices
        let _devices = []
        for (let i = 0; i < data[2].Devices.length; i++) {
          _devices.push({
            value: data[2].Devices[i].SerialNumber,
            name: data[2].Devices[i].FriendlyName + ' (' + data[2].Devices[i].Status.Text + ')',
            id: data[2].Devices[i].Id,
            friendlyName: data[2].Devices[i].FriendlyName
          })
        }
        state.devices = _devices
        // Protocols
        // let _protocols = []
        // for (let i = 0; i < data[3].Protocols.length; i++) {
        //   _protocols.push({
        //     value: data[3].Protocols[i].Value,
        //     name: data[3].Protocols[i].Text
        //   })
        // }
        // state.protocols = _protocols
        // Interfaces
        // let _interfaces = []
        // for (let i = 0; i < data[4].Interfaces.length; i++) {
        //   _interfaces.push({
        //     value: data[4].Interfaces[i].Value,
        //     name: data[4].Interfaces[i].Text
        //   })
        // }
        // state.interfaces = _interfaces
        // Statuses
        // let _statuses = []
        // for (let i = 0; i < data[5].Statuses.length; i++) {
        //   _statuses.push({
        //     value: data[5].Statuses[i].Id,
        //     name: data[5].Statuses[i].Text
        //   })
        // }
        // state.statuses = _statuses
        // Scan Types
        // let _scanTypes = []
        // for (let i = 0; i < data[6].ScanTypes.length; i++) {
        //   _scanTypes.push({
        //     value: data[6].ScanTypes[i].Id,
        //     name: data[6].ScanTypes[i].Text
        //   })
        // }
        // state.scanTypes = _scanTypes
        state.dtcs = data[7].DTCs
        state.odometerUnits = data[8].OdometerUnits
        state.insurances = data[9].Insurances
        state.timeZones = data[10].TimeZones
        state.years = data[11].Years
        state.contacts = data[12].Contacts
        store.dispatch('businesses/setBusinessContacts', state.contacts)
        state.apiUrl = data[15].ApiUrl
        // Ready the Scan History, including the links for the Reports.
        if (data[13].ReviewScans.Result !== undefined && data[13].ReviewScans.Result !== null) {
          let _scans = JSON.parse(data[13].ReviewScans.Result)
          for (let scan of _scans) {
            state.workOrder.PreviousScans.push({
              Id: scan.Id + ' (review scan)',
              Text: scan.Text,
              Value: scan.Value,
              Type: 'Review',
              Url: state.apiUrl.replace('http', 'https') + '/Report/CreateReviewPdf?id=' + scan.Id + '&sendEmail=false'
            })
          }
        }
        // Damage Positions
        // default the damage positions
        let _damagePositions = []
        for (let i = 0; i < data[14].DamagePositions.length; i++) {
          _damagePositions.push({
            id: data[14].DamagePositions[i].Id,
            cx: data[14].DamagePositions[i].CX,
            cy: data[14].DamagePositions[i].CY,
            svgId: data[14].DamagePositions[i].SvgId,
            text: data[14].DamagePositions[i].Text
          })
        }
        state.damagePositions = _damagePositions
        // BusinessInfo
        state.businessInfo = data[16].BusinessInfo
        // set the Hub Assigned Tool
        // default the assigned tool for this Work Order
        if (state.hubData !== null && state.hubData !== undefined) {
          state.hubData.asTechTool = null
          if (state.dispatchWorkOrders !== null && state.dispatchWorkOrders !== undefined) {
            for (let tool of state.dispatchWorkOrders) {
              if (tool.id === state.workOrder.Id) {
                state.hubData.asTechTool = {
                  id: tool.assignedToolID,
                  serialNumber: tool.assignedToolSN,
                  value: tool.assignedTool,
                  status: 1
                }
                break
              }
            }
          }
        }
        if (data[17] !== undefined && data[17] !== null) {
          state.lineCount = data[17].LineCount
        }
      }
    }
  },
  [types.SET_WORK_ORDER_HISTORY](state, data) {
    state.workOrderHistory = null
    if (data !== '') {
      state.workOrderHistory = data
    }
  },
  [types.SET_WORK_ORDERS](state, data) {
    // Set the Work Orders listing with data coming back
    // from the server.  We'll update everything as
    // 'WorkOrder' and set them all to 'not selected'.
    state.workOrders = data
    if (state.workOrders !== undefined && state.workOrders !== null) {
      if (state.workOrders.items !== null) {
        for (let workOrder of state.workOrders.items) {
          workOrder.type = 'WorkOrder'
          workOrder.isSelected = false
        }
      }
    }
  },
  [types.SET_SELECTED](state, id) {
    for (let workOrder of state.workOrders.items) {
      workOrder.isSelected = false
      if (workOrder.id === id) {
        workOrder.isSelected = true
      }
    }
  },
  [types.GET_REPAIR_LINES](state, data) {
    state.repairLines = null
    if (!data.data.error) {
      state.repairLines = data.data[0].Lines
    }
  },
  [types.SET_WORK_ORDER_NOTES](state, data) {
    state.workOrder.Notes.Notes = data.Notes
  },
  [types.SET_WORK_ORDER_STATUS](state, data) {
    console.log('Setting Work Order Status', data)
    // After the Master Tech starts the scan,
    // we'll update the Work Order status along
    // with the appropriate Dispatch tables.
    // The results coming back are used to update the
    // local status in the UI.
    if (state.workOrder !== null) {
      state.workOrder.Status = {
        Id: data.Status.Id,
        Name: data.Status.Text
      }
      for (let workOrder of state.workOrders.items) {
        if (workOrder.id === state.workOrder.Id) {
          workOrder.statusId = data.Status.Id
          workOrder.statusName = data.Status.Text
          // workOrder.dispatchStatus = data.DispatchStatus.Text
          break
        }
      }
    }
  },
  [types.SET_WORK_ORDER_SCHEDULE](state, data) {
    for (let workOrder of state.workOrders.items) {
      if (workOrder.id === state.workOrder.Id) {
        workOrder.scheduled = data.scheduleDateTime
      }
    }
  },
  [types.SET_WORK_ORDER_SCAN_TYPE](state, data) {
    let _scanType = {}
    let _name = ''
    for (let scanType of state.scanTypes) {
      if (scanType.value === parseInt(data.scanTypeId)) {
        _name = scanType.name
        _scanType = {
          Name: scanType.name,
          Id: scanType.value
        }
        break
      }
    }
    state.workOrder.ScanType = _scanType
    for (let workOrder of state.workOrders.items) {
      if (workOrder.id === data.workOrderId) {
        workOrder.scanTypeId = data.scanTypeId
        workOrder.scanTypeName = _name
        break
      }
    }
  },
  [types.SET_WORKORDER_ASSIGNMENT](state, status) {
    // console.log('WO Assignment', data)
    // let status = JSON.parse(data)
    if (state.workOrders !== undefined && state.workOrders !== null) {
      if (state.workOrders.items !== undefined && state.workOrders.items !== null) {
        for (let workOrder of state.workOrders.items) {
          if (workOrder.id === status.workOrderId) {
            console.log('Set Work Order Assignment', workOrder)
            if (status.userId > 0) {
              workOrder.assignedUser = status.assignedUserName
            }
            if (status.toolId > 0) {
              workOrder.assignedTool = status.toolName
            }
          }
        }
      }
    }
  },
  [types.REFRESH_WORK_ORDER](state, data) {
    state.workOrder.ScanReport.Id = data.ScanReportId
    state.workOrder.ScanReport.Status.Text = data.ScanReportStatus
    state.workOrder.Status.Text = data.WorkOrderStatus
    state.workOrder.ScanReport.InvoiceNumber = data.InvoiceNumber
  },
  [types.SET_HUB_DATA](state, data) {
    state.hubData = Object.assign({}, data)
  },
  [types.SET_DEVICE_STATISTIC_INTERVAL](state, data) {
    state.deviceStatisticInterval = data
  },
  [types.SET_DISPATCH_WORK_ORDERS](state, data) {
    // This updates the Work Orders listing already pulled down.
    // It turns out, this is faster than trying to get the
    // Dispatch status for those Work Orders in the same query.
    // Here, we just update a few columns with the Dispatch information.
    state.dispatchWorkOrders = data
    for (let workOrder of state.workOrders.items) {
      workOrder.assignedTool = ''
      workOrder.assignedUser = ''
      workOrder.elapsedTime = ''
      workOrder.dispatchStatus = ''
      workOrder.reassignNote = ''
      for (let dispatch of data) {
        if (dispatch.id === workOrder.id) {
          workOrder.assignedTool = dispatch.assignedTool
          workOrder.assignedUser = dispatch.assignedUser
          workOrder.elapsedTime = global.dates.elapsedTime(dispatch.lastEditedTime, dispatch.status, workOrder.statusName)
          workOrder.dispatchStatus = (dispatch.status === 'Submitted') ? 'Unassigned' : dispatch.status
          workOrder.scheduled = dispatch.scheduledTime
          workOrder.reassignNote = dispatch.reassignNote
          break
        }
      }
    }
  },
  [types.FILTER_WORK_ORDERS](state, filter) {
    // This filters the current Work Orders listing (for Dispatch users) to the 15 min tab
    // When the Dispatch user goes back to the main Work Orders listing, it'll be a
    // call back to the server.
    if (state.workOrders !== undefined && state.workOrders !== null) {
      if (state.workOrders.items !== null) {
        let _workOrders = JSON.parse(JSON.stringify(state.workOrders.items))
        if (filter === 'waitTab') {
          var filteredArray = _workOrders.filter(function (el) {
            return global.dates.isGreater15(el.elapsedTime)
          })
          state.workOrders.items = JSON.parse(JSON.stringify(filteredArray))
        }
      }
    }
  },
  [types.SET_TOOLBARMENU_REQUEST_HELP](state, data) {
    state.helprequests = []
    let temp = []
    temp.push({
      displayname: '',
      helprequest: '',
      status: null,
      userid: 0,
      username: null,
      workorderid: 0
    })
    if (data !== '') {
      state.helprequests = temp.concat(data)
    }
  },
  [types.UPDATE_SCAN_REPORT_FOLLOW_UP](state, value) {
    if (value) {
      state.workOrder.ScanReport.IsFollowupScan = 1
    } else {
      state.workOrder.ScanReport.IsFollowupScan = 0
    }
  },
  [types.UPDATE_SCAN_REPORT](state, details) {
    switch (details.area) {
      case 'ServiceDetails':
        state.workOrder.ScanReport.ServiceDetails = details.data
        break
      case 'Recommendations':
        state.workOrder.ScanReport.Recommendations = details.data
        break
      case 'ScanReadings':
        state.workOrder.ScanReport.ScanReadings = details.data
        break
      case 'SnapShotData':
        state.workOrder.ScanReport.SnapshotData = details.data
        break
    }
  },
  [types.UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING](state, value) {
    console.log('UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING - value', value)
    if (value) {
      state.workOrder.ScanReport.IsProgrammingPerformed = 1
    } else {
      state.workOrder.ScanReport.IsProgrammingPerformed = 0
    }
  },
  [types.SET_WORKORDER_VEHICLE](state, data) {
    console.log('saved vehicle', data)
    state.workOrder.Vehicle.VIN = data.VIN
    state.workOrder.Vehicle.Year = data.Year
    state.workOrder.Vehicle.DriveType.Id = data.DriveType.Id
    state.workOrder.Vehicle.Engine.Id = data.Engine.Id
    state.workOrder.Vehicle.Make.Id = data.Make.Id
    state.workOrder.Vehicle.Model.Id = data.Model.Id
    state.workOrder.Vehicle.Odometer = data.Odometer
    state.workOrder.Vehicle.OdometerUnits.Id = data.OdometerUnits.Id
    state.workOrder.Vehicle.Submodel.Id = data.Submodel.Id
    state.workOrder.Vehicle.Transmission.Id = data.Transmission.Id
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/work-orders/mutations.js